Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = isPromise;
// to support Promise-like object.
function isPromise(value) {
    return value && typeof value.then === "function";
}